import { auth } from '@tabletuck/firebase-services';
import { environment } from 'apps/table-tuck-web/src/environments/environment';

/**
 * Call backend to update the authenticated user's email.
 *
 * Requirements:
 * - Backend route: POST /updateEmail/:userId
 * - Query: restaurantId (environment.restaurantId)
 * - Headers: authorization (Firebase ID token), Content-Type: application/json
 * - Body: { email }
 *
 * Returns the parsed JSON response on success.
 * Throws an Error with a user‑friendly message on failure.
 */
export const updateUserEmailViaApi = async ({ email, userId }) => {
  if (!email) {
    throw new Error('Email is required.');
  }

  // Basic guards
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('No authenticated user found. Please log in again.');
  }

  const idToken = await currentUser.getIdToken();
  if (!idToken) {
    throw new Error('Failed to retrieve authentication token. Please try again.');
  }

  const url = `${environment.apiUrl}/updateEmail/${userId}?restaurantId=${environment.restaurantId}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: idToken,
    },
    body: JSON.stringify({ email }),
  });

  let data = null;
  try {
    data = await response.json();
  } catch (jsonError) {
    // Non‑JSON response
  }

  const isSuccessField =
    typeof data?.isSuccess === 'boolean' ? data.isSuccess : undefined;
  const isStatusFail = data?.status === 'fail';

  if (!response.ok || isSuccessField === false || isStatusFail) {
    const message =
      data?.error?.message ||
      data?.shortMessage ||
      data?.message ||
      data?.error ||
      'Failed to update email. Please try again.';
    throw new Error(message);
  }

  return data;
};

